import { inject, PLATFORM_ID } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { selectIsAuthenticated } from '../store/auth/auth.selectors'
import { catchError, filter, map, of, switchMap, take, tap } from 'rxjs'
import { eps } from '../services/url.service'
import { AuthService } from '../services/auth.service'
import { refreshTokenFailure, refreshTokenSuccess } from '../store/auth/auth.actions'
import { selectAuthLoaded } from '../store/auth/auth.state'
import { isPlatformBrowser } from '@angular/common'

// export const authGuard: CanActivateFn = () => {
//   const router = inject(Router)
//   return inject(Store)
//     .select(selectIsAuthenticated)
//     .pipe(
//       take(1),
//       tap(isAuth => {
//         if (!isAuth) router.navigate([eps.auth.loginPath])
//       }),
//       map(isAuth => isAuth)
//     )
// }

// export const authGuard: CanActivateFn = () => {
//   const store = inject(Store)
//   const authService = inject(AuthService)
//   const router = inject(Router)

//   return store.select(selectIsAuthenticated).pipe(
//     take(1),
//     switchMap(isAuth => {
//       // console.log('auth guard')
//       if (isAuth) {
//         return of(true)
//       } else {
//         // console.log('auth guard')
//         // Try to refresh token
//         return authService.refreshToken().pipe(
//           tap(({ accessToken, user, refreshToken }) => {
//             localStorage.setItem('accessToken', accessToken)
//             localStorage.setItem('user', JSON.stringify(user))
//             localStorage.setItem('refreshToken', refreshToken)
//             store.dispatch(refreshTokenSuccess({ accessToken, user }))
//           }),
//           map(() => true),
//           catchError(error => {
//             // console.log('error', error)
//             store.dispatch(refreshTokenFailure())
//             router.navigate([eps.auth.loginPath])
//             return of(false)
//           })
//         )
//       }
//     })
//   )
// }

//29 june 2026
// export const authGuard: CanActivateFn = () => {
//   const store = inject(Store)
//   const authService = inject(AuthService)
//   const router = inject(Router)

//   return store.select(selectAuthLoaded).pipe(
//     take(1),

//     switchMap(loaded => {
//       // ⛔ Wait until store is ready
//       if (!loaded) {
//         return of(false) // or a loading spinner route
//       }

//       return store.select(selectIsAuthenticated).pipe(
//         take(1),
//         switchMap(isAuth => {
//           if (isAuth) return of(true)

//           return authService.refreshToken().pipe(
//             tap(({ accessToken, user, refreshToken }) => {
//               localStorage.setItem('accessToken', accessToken)
//               localStorage.setItem('user', JSON.stringify(user))
//               localStorage.setItem('refreshToken', refreshToken)

//               store.dispatch(refreshTokenSuccess({ accessToken, user }))
//             }),
//             map(() => true),

//             catchError(() => {
//               store.dispatch(refreshTokenFailure())
//               console.log('auth guard error')
//               router.navigate([eps.auth.loginPath])
//               return of(false)
//             })
//           )
//         })
//       )
//     })
//   )
// }

//30 june 2026

export const authGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID)

  // ✅ Server pe block mat karo, client pe hi real check chalega
  if (!isPlatformBrowser(platformId)) {
    return true
  }

  const store = inject(Store)
  const authService = inject(AuthService)
  const router = inject(Router)

  return store.select(selectAuthLoaded).pipe(
    filter(loaded => loaded === true),
    take(1),
    switchMap(() =>
      store.select(selectIsAuthenticated).pipe(
        take(1),
        switchMap(isAuth => {
          if (isAuth) return of(true)

          return authService.refreshToken().pipe(
            tap(({ accessToken, user, refreshToken }) => {
              localStorage.setItem('accessToken', accessToken)
              localStorage.setItem('user', JSON.stringify(user))
              localStorage.setItem('refreshToken', refreshToken)
              store.dispatch(refreshTokenSuccess({ accessToken, user }))
            }),
            map(() => true),
            catchError(() => {
              store.dispatch(refreshTokenFailure())
              router.navigate([eps.auth.loginPath])
              return of(false)
            })
          )
        })
      )
    )
  )
}
